// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectParam_dropdown__JZlHQ {
  position: relative;
  display: inline-block;
  width: 120px;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer; }

.selectParam_dropdownSelected__6Z2bm {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center; }

.selectParam_dropdownArrow__89Zwz {
  margin-left: 10px; }

.selectParam_dropdownList__5bbPB {
  border-radius: 4px;
  background-color: #fff;
  margin: 0;
  padding: 0;
  list-style: none;
  overflow-y: auto;
  box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2);
  border-radius: 4px; }

.selectParam_dropdownItem__gOfDs {
  font-size: 14px;
  line-height: 20px;
  padding: 4px;
  cursor: pointer; }

.selectParam_dropdownItem__gOfDs:hover,
.selectParam_dropdownItem__gOfDs.selectParam_selected__WnpQQ {
  background-color: rgba(254, 97, 0, 0.1); }
`, "",{"version":3,"sources":["webpack://./src/pages/OrdersViewD3/components/selectParam.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB,EAAA;;AAGrB;EACE,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,8GAA8G;EAC9G,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe,EAAA;;AAGjB;;EAEE,uCAAuC,EAAA","sourcesContent":[".dropdown {\n    position: relative;\n    display: inline-block;\n    width: 120px;\n    user-select: none;\n    cursor: pointer;\n  }\n  \n  .dropdownSelected {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: #fff;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .dropdownArrow {\n    margin-left: 10px;\n  }\n  \n  .dropdownList {\n    border-radius: 4px;\n    background-color: #fff;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    overflow-y: auto;\n    box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2);\n    border-radius: 4px;\n  }\n  \n  .dropdownItem {\n    font-size: 14px;\n    line-height: 20px;\n    padding: 4px;\n    cursor: pointer;\n  }\n  \n  .dropdownItem:hover,\n  .dropdownItem.selected {\n    background-color: rgba(254, 97, 0, 0.1);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `selectParam_dropdown__JZlHQ`,
	"dropdownSelected": `selectParam_dropdownSelected__6Z2bm`,
	"dropdownArrow": `selectParam_dropdownArrow__89Zwz`,
	"dropdownList": `selectParam_dropdownList__5bbPB`,
	"dropdownItem": `selectParam_dropdownItem__gOfDs`,
	"selected": `selectParam_selected__WnpQQ`
};
export default ___CSS_LOADER_EXPORT___;
